import { useState, useMemo, useEffect } from "react";
import StressButton from "../../../components/StressButton";
import Results from "./Results";

const ListenAndClickStress = ({numStress, tracks, progress, setProgress, nextTab, nextExercise, resultsHandler, tab}) => {
    const [track, setTrack] = useState(0);
    const [animatePulse, setAnimatePulse] = useState(Array(numStress).fill(false));
    const [animateRight, setAnimateRight] = useState(Array(numStress).fill(false));
    const [animateWrong, setAnimateWrong] = useState(Array(numStress).fill(false));
    const [registerHit, setRegisterHit] = useState(false);
    const [results, setResults] = useState({'results': [], 'value': []});
    const [scores, setScores] = useState(progress[tab] ? progress[tab] : []);
    const [resultPage, setResultPage] = useState(false);
    const [playState, setPlayState] = useState(false) // sounds are played when true
    const [start, setStart] = useState(false);
    const [buttonState, setButtonState] = useState(false) // pair buttons are disabled when false

    const choice = tracks[track][0];
    const target = tracks[track][1];

    const audios = useMemo(() => {
        return choice.slice(0, numStress).map(c => new Audio(c.audio));
    }, [choice]);
    const audioTarget = useMemo(() => new Audio(target.audio), [target]);

    const PushResult = (b) => {
        let r2 = results;
        r2.results.push({
            choice: choice,
            target: target,
            eval: b
        });
        r2.value.push(b);
        setResults(r2);
    }

    const PlayNext = () => {
        var audioDuration = 2000;
        if (audios[0].duration) {
            audioDuration = audios[0].duration*1000 + 300;
        if (audios[1].duration) {
            audioDuration = Math.max(audios[0].duration*1000, audios[1].duration*1000)+300;
        }
        } else {
            if (audios[1].duration){
                audioDuration = audios[1].duration*1000 + 300;
            }
        }
    
        setTimeout(() => {
            if (track < tracks.length - 1) {
                setTrack(track + 1);
                setButtonState(false);
                setPlayState(true);
                setRegisterHit(false);
                const animateArray = Array(numStress).fill(false);
                setAnimatePulse(animateArray);
                setAnimateRight(animateArray);
                setAnimateWrong(animateArray);
            } else {
                setResultPage(true);
                resultsHandler(results);
            }
        }, audioDuration);

    }

    const Play = (i) => {
        audios[i].play();
        setRegisterHit(true);
        let animateArray = Array(numStress).fill(false);
        setAnimatePulse(animateArray);
        animateArray[i] = true;
        if (choice[i].word === target.word) {
            PushResult(true);
            setAnimateRight(animateArray);
            setScores([...scores, 1]);
        } else {
            PushResult(false);
            setAnimateWrong(animateArray);
            setScores([...scores, 0]);
        }
        PlayNext();
    }

    const FireUp = (i) => {
        console.log("FIREUP");
        audios[i-1].removeEventListener("ended", () => {FireUp(i)});
        setTimeout(() => {
            let array = Array(numStress).fill(false);
            array[i] = true;
            setAnimatePulse(array);
            audios[i].play();
        }, 500);
    }

    const FireUpTarget = () => {
        setTimeout(() => {
            setAnimatePulse(Array(numStress).fill(false));
        }, 200);
        console.log("FIREUPTARGET");
        audios[1].removeEventListener("ended", FireUpTarget);
        setTimeout(() => {
            setAnimatePulse(Array(numStress).fill(true));
            audioTarget.play();
        }, 300);
    }

    const Button = ({button}) => <div className="flex flex-col items-center w-full">
        <div>
            <button
                disabled={!buttonState || registerHit}
                className={`
                    choice-button !min-w-0 animate__animated my-2 md:my-0
                    ${animatePulse[button] && "animate__pulse"}
                    ${animateRight[button] && "animate__tada bg-green-500 border-green-700 opacity-60"}
                    ${animateWrong[button] && "animate__shakeX bg-red-500 border-red-700 opacity-60"}
                    ${!animateRight[button] && !animateWrong[button] ? "bg-[#176b87] hover:bg-[#0f5269]" : ""}`
                }
                style={{ '--animate-duration': '1s' }} // Change the duration of the animation here. Default: 1s
                onClick={() => {Play(button)}}
            >
                <StressButton numStress={numStress} mainStress={button} /> 
            </button>
        </div>
    </div>

    useEffect(() => {
        let mounted = true;
        const handleCanPlayThrough = () => {
            console.log("HANDLECANPLAYTHROUGH");
            audios[0].removeEventListener("canplaythrough", handleCanPlayThrough);
            if (mounted) {
                setTimeout(() => {
                    audios[0].play();
                    let array = Array(numStress).fill(false);
                    array[0] = true;
                    setAnimatePulse(array);
                }, 300);
            }
        }

        if (playState) {
            setTimeout(() => {
                audios[0].addEventListener("canplaythrough", handleCanPlayThrough);
                for (let i = 0; i < numStress - 1; i++) {
                    audios[i].addEventListener("ended", () => {FireUp(i+1)});
                }
                audios[numStress-1].addEventListener("ended", FireUpTarget);
                audioTarget.addEventListener("ended", () => {
                    setButtonState(true);
                    setPlayState(false);
                });
                for (let audio of audios) {
                    audio.currentTime = 0;
                }
                audioTarget.currentTime = 0;
            }, 300);
        } else {
            mounted = false;
            // Differences between the merged files I didn't understand
            if (numStress === 2) {
                console.log("2FIREUPTARGET");
                audios[1].removeEventListener("ended", FireUpTarget)
                console.log("2SETBUTTONSTATE");
                audioTarget.removeEventListener("ended", ()=>{setButtonState(true);})
                audios[0].pause();
                audios[1].pause();
                audioTarget.pause();
            } else {
                console.log("3FIREUPTARGET");
                audios[1].removeEventListener("ended", FireUpTarget)
                console.log("3SETBUTTONSTATE");
                audios[2].removeEventListener("ended", ()=>{setButtonState(true);})
                audios[0].pause();
                audios[1].pause();
                audios[2].pause();
            }
        }
    }, [track, playState]);

    // Tracks the scorers for the exercise
    useEffect(() => {
    setProgress(prevProgress => {
        const newProgress = [...prevProgress];
        newProgress[tab] = scores;
        return newProgress;
    })
    },[scores]);

    if (resultPage) {
        return <div className="flex w-full flex-col items-center justify-center">
            <Results
                results={results.value}
                nextTab={nextTab}
                nextExercise={nextExercise}
            />
        </div>
    }    

    return <div className="flex w-full flex-col items-center justify-center">
        {/* PLAY BUTTON */}
        <div className={`mx-auto md:pb-7 ${numStress === 2 ? "pt-7 pb-10" : "py-5"}`}>
            <button 
                disabled={playState || registerHit}
                className="audio-button"
                
                onClick={() => {setPlayState(true); setStart(true)}}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32.00 32.00"
                    fill="white"
                    className={`w-12 h-12 `}
                >
                  <path d="M16,6v20c0,1.1-0.772,1.537-1.715,0.971l-6.57-3.942C6.772,22.463,5.1,22,4,22H3c-1.1,0-2-0.9-2-2 v-8c0-1.1,0.9-2,2-2h1c1.1,0,2.772-0.463,3.715-1.029l6.57-3.942C15.228,4.463,16,4.9,16,6z M26.606,5.394 c-0.781-0.781-2.047-0.781-2.828,0s-0.781,2.047,0,2.828C25.855,10.3,27,13.062,27,16s-1.145,5.7-3.222,7.778 c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586C29.439,23.773,31,20.007,31,16 S29.439,8.227,26.606,5.394z M22.363,9.636c-0.781-0.781-2.047-0.781-2.828,0s-0.781,2.047,0,2.828C20.479,13.409,21,14.664,21,16 s-0.52,2.591-1.464,3.535c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 C24.064,20.664,25,18.404,25,16S24.063,11.336,22.363,9.636z"></path>
                </svg>
            </button>
        </div>
        <div className={`${numStress === 2 && "md:w-4/5 "}w-full grid grid-cols-1 md:grid-cols-3 items-center justify-center text-center md:py-5 ${start ? "opacity-100" : "opacity-40"}`}>
            {numStress === 2 ? <>
                <Button button={0} />
                <h1 className="text-gray-500 font-mono font-bold"> or </h1>
                <Button button={1} />
            </> : [...Array(numStress)].map((_, i) => <Button button={i} />)}
            {/* Translations */}
            <p className="hidden md:block col-start-1 break-word text-sm mt-2 pt-1 text-gray-500"> {choice[0].translation} </p>
            <p className={`hidden md:block col-start-${numStress} break-word text-sm mt-2 pt-1 text-gray-500`}> {choice[1].translation} </p>
            {numStress === 3 && <p className="hidden md:block col-start-3 break-word text-sm mt-2 pt-1 text-gray-500"> {choice[2].translation} </p>}
        </div>
    </div>
}

export default ListenAndClickStress;
